import { LoadingButton } from '@mui/lab';
import { AppBar, Toolbar, Typography, Button, Stack, TextField, Divider, LinearProgress, CircularProgress, MenuItem } from '@mui/material'
import { addDoc, arrayUnion, collection, doc, updateDoc } from 'firebase/firestore';
import { getDownloadURL, getStorage, ref, uploadBytesResumable } from 'firebase/storage';
import React, { useState } from 'react'
import Dropzone from 'react-dropzone';
import { auth, db } from '../../../firebase';
import buildingCategories from '../../../_mock/buildingCategories';
// eslint-disable-next-line react/prop-types
function SellItem({handleClose}) {
    const storage = getStorage()    
    const [images, setImages] = useState([]);
    const [loading, setloading] = useState(false)
    const [uploadProgress, setUploadProgress] = useState(0);
    const [category, setcategory] = useState(null)
 const [name, setname] = useState(null)
 const [price, setprice] = useState(null)
 const [condition, setcondition] = useState(null)
 const [type, settype] = useState(null)
 const [description, setdescription] = useState(null)
 const [location, setlocation] = useState(null)

    const handleMultipleImageChange = () => {
      if (images && images.length > 0) { 
        const selectedImages = Array.from(images);       
        if (selectedImages.length > 5) { 
          const firstTenImages = selectedImages.slice(0, 5);
          uploadImages(firstTenImages) 
        } else {
          uploadImages(selectedImages) 
        }
      }
    };


    const uploadImages = async (images) => {
  setloading(true)

  if (!name || !price || !condition || !type || !description || !location || !category) {
    alert("Fill in all the fields.")// Handle the case where any of the required fields are missing
    console.error("Required fields are missing!");
  } else {
    const docId = await addDoc(collection(db, 'marketplace'), {
      name,
      price,
      condition,
      type,
      description,
      location,
      category,
      createdAt: Date.now(),
      userId: auth.currentUser.uid
    });
  
    // Document added successfully
    console.log("Document added with ID: ", docId);
    const storageRef = ref(storage, `marketplace/${docId.id}/`); // Define the storage reference
    // eslint-disable-next-line no-async-promise-executor
     const uploadPromises = images.map((image) => new Promise(async (resolve) => {
         const fileRef = ref(storageRef, image.name);
         const uploadTask = uploadBytesResumable(fileRef, image); 
         uploadTask.on('state_changed',
           (snapshot) => {
             const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
             setUploadProgress(Math.round(progress)) 
           },
           (error) => {
             console.error(`Error uploading ${image.name}: ${error.message}`);
             resolve(null);
           },
           () => {
             // Upload completed successfully
             getDownloadURL(fileRef).then(async (downloadURL) => {
               console.log(`File ${image.name} available at ${downloadURL}`);
                const userDocRef = doc(db, 'marketplace', docId.id );
               await updateDoc(userDocRef, {
                 images: arrayUnion(downloadURL),
               });
                 resolve(downloadURL);
             });
           }
         );
       }));
   
     try {
       const uploadedImageUrls = await Promise.all(uploadPromises);
       console.log('All images uploaded:', uploadedImageUrls);
       setImages([]); // Clear the uploaded images
       handleClose()
        } catch (error) {
       console.error('Error uploading images:', error);
        
     }
  }


     
    };
    
    const provinces = [
      "Central",
      "Copperbelt",
      "Eastern",
      "Luapula",
      "Lusaka",
      "Muchinga",
      "Northern",
      "North-Western",
      "Southern",
      "Western"
    ];
  
       
console.log(auth.currentUser?.uid )

  return (
    auth.currentUser?.uid && <div>
           <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
          
            <Typography>Sell/Rent </Typography>
          </Toolbar>
        </AppBar>
        <Stack spacing={3} alignItems={"center"} p={3} >
        <TextField
        fullWidth select
        label="Type"
        value={type}
        onChange={(event) => settype(event.target.value)}
      >
           <MenuItem value="SELL">Sell</MenuItem>
      <MenuItem value="RENT">Rent</MenuItem>
      <MenuItem value="HIRE">Hire</MenuItem>
      </TextField>

            <TextField fullWidth select label="Category" value={category} onChange={(event) => setcategory(event.target.value)}>
      {buildingCategories.map((bc, index)=>(
        <MenuItem value={bc.name} key={index}>{bc.name}</MenuItem>
      ))}
      </TextField>

      <TextField
        fullWidth 
        label="Title"
        value={name}
        onChange={(event) => setname(event.target.value)}
      />
         <TextField
        fullWidth rows={5} multiline
         type="post"
        label="Description"
        value={description}
        onChange={(event) => setdescription(event.target.value)}
      />
      <TextField
        fullWidth 
         type="number"
        label="Price"
        value={price}
        onChange={(event) => setprice(event.target.value)}
      />
       <TextField
        fullWidth select
        label="Condition"
        value={condition}
        onChange={(event) => setcondition(event.target.value)}
      >
      <MenuItem value="NEW">New</MenuItem>
      <MenuItem value="GOOD">Used - Good</MenuItem>
      <MenuItem value="LIKE_NEW">Used - Like New</MenuItem>
      <MenuItem value="FAIR">Used - Fair</MenuItem>
      </TextField>
     
      
    
      <TextField fullWidth select label="Location" value={location} onChange={(event) => setlocation(event.target.value)}>
      {provinces.map((p, index)=>(
        <MenuItem value={p} key={index}>{p}</MenuItem>
      ))}
      </TextField>

      <Typography sx={{ ml: 2, flex: 1 }} variant="body1" component="div">
           Choose your listing's main photo first. You can add 5 pictures
            </Typography>
            <Dropzone onDrop={files => setImages(files)}>
                {({getRootProps, getInputProps}) => (
                  <div className="container">
                    <div
                      {...getRootProps({
                        className: 'dropzone',
                        onDrop: event => event.stopPropagation()
                      })}
                    >
                      <input {...getInputProps()} multiple />
                      <p>Click to select files</p>
                    </div>
                    <br/>
                  </div>
                )}
              </Dropzone>

     
        {images.length > 0 && 
        <>
        <CircularProgress fullWidth
      variant="determinate"
      value={uploadProgress}
      sx={{ my: 2 }}
    />
      <LoadingButton loading={loading} fullWidth variant="contained" onClick={()=>handleMultipleImageChange()} color="success">Upload</LoadingButton>
      </>}
      <Typography sx={{ ml: 2, flex: 1 }} variant="overline" component="div">
           Listings on the marketplace are public and can be seen by people on and off the platform. Listings may also be used for promotion of the platform.
            </Typography>

        </Stack>
      
    </div>
  )
}
export default SellItem